import { DayInput, MonthInput, YearInput } from '../baseInputs'

type Props = {
  optional?: boolean
}

const DateOfBirth = ({ optional, ...rest }: Props) => {
  const label = 'Date of Birth'
  return (
    <div
      className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 md:gap-4 items-start justify-top mb-4 md:mb-2"
      data-gt-name="componentevent"
    >
      <div className="md:col-span-2 lg:col-span-1">
        <label className="block">
          <span className="inline-block text-base-text mb-1">
            {label}{' '}
            {optional && (
              <span className="text-xs lowercase whitespace-nowrap">
                (optional)
              </span>
            )}
          </span>
        </label>
        <div className="grid lg:grid-cols-6 grid-cols-3 gap-4">
          <DayInput label={label} name="day" {...rest} />
          <MonthInput name="month" {...rest} />
          <YearInput name="year" {...rest} />
        </div>
      </div>
    </div>
  )
}

export default DateOfBirth
